import type { DocumentRecord } from '../../shared/types'
import type { AiProposal } from './AiAssistant'

export function DiffPreview({ document, proposal }: { document: DocumentRecord; proposal: AiProposal }) {
  return (
    <section className="diff-preview" aria-label="AI 修改预览">
      <div className="proposal-summary"><span>AI 建议</span><p>{proposal.summary}</p></div>
      <h3>{proposal.title}</h3>
      <div className="diff-stats"><span>标题{proposal.title === document.title ? '保持不变' : '将被更新'}</span><span>正文 {document.content.length} → {proposal.content.length} 字符</span></div>
      <pre>{proposal.content || '（空白文档）'}</pre>
    </section>
  )
}
